/**
 * @generated SignedSource<<8cb702f9515e39d60c5c9bdc70f2a968>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type salesChannelConnectModelMutation$variables = {
  id: string;
  target: ModelDuplicateTargetInput;
};
export type salesChannelConnectModelMutation$data = {
  readonly connectModel: string;
};
export type salesChannelConnectModelMutation = {
  response: salesChannelConnectModelMutation$data;
  variables: salesChannelConnectModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "target"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "target",
        "variableName": "target"
      }
    ],
    "kind": "ScalarField",
    "name": "connectModel",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelConnectModelMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelConnectModelMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "a2c4ee75c911f0b6c70629165882ad82",
    "id": null,
    "metadata": {},
    "name": "salesChannelConnectModelMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelConnectModelMutation(\n  $id: ID!\n  $target: ModelDuplicateTargetInput!\n) {\n  connectModel(id: $id, target: $target)\n}\n"
  }
};
})();

(node as any).hash = "18fb257e0e5e80cf855045777af1a729";

export default node;
